<script>
import LevelContainer from '@/game/LevelContainer'

export default {

  components: {
    LevelContainer
  },

  props: {
    levelId: {
      type: String,
      required: true
    }
  },

  watch: {

    levelId (newLevelId, oldLevelId) {
      if (newLevelId !== oldLevelId) {
        this.init()
      }
    }

  },

  created () {
    this.init()
  },

  methods: {

    init () {

      // Reset new level if not already loaded
      if (this.$store.getters.currentLevelId !== this.levelId) {
        this.$store.dispatch('resetGameplayState')
        this.$store.dispatch('setCurrentLevelId', this.levelId)
        this.$store.dispatch('resetCurrentLevel')
      }
    }

  }

}
</script>

<template>
  <level-container
    :key="levelId"
    class="c-view-level"
  />
</template>

<style lang="scss">

.c-view-level {
  width: 100%;
  height: 100%;
}

</style>
